export const breakpoint = {
  xsmall: 450,
  small: 640,
  medium: 768,
  large: 1024,
  xlarge: 1280,
  xxlarge: 1600,
}
